
import React from 'react';
import { Button } from '@/components/ui/button';
import { Phone } from 'lucide-react';
import { trackPhoneCall } from '@/services/menuViewService';

interface TrackPhoneCallProps {
  restaurantId: string;
  phone: string;
  className?: string;
  buttonStyle?: boolean;
}

const TrackPhoneCall: React.FC<TrackPhoneCallProps> = ({ restaurantId, phone, className, buttonStyle = false }) => {
  // If there's no phone number, don't render anything
  if (!phone || phone.trim() === '') {
    console.log('No phone number provided to TrackPhoneCall');
    return null;
  }

  const handlePhoneClick = () => {
    // Track the phone call
    trackPhoneCall(restaurantId)
      .then(() => console.log('Phone click tracked successfully'))
      .catch(err => console.error('Error tracking phone click:', err));
    
    // Open the phone dialer
    window.location.href = `tel:${phone}`;
  };

  if (buttonStyle) {
    return (
      <Button 
        variant="outline" 
        size="sm" 
        className={className || "bg-white/80 hover:bg-white z-10"}
        onClick={handlePhoneClick}
      >
        <Phone className="mr-2 h-4 w-4" />
        Appeler
      </Button>
    );
  }

  return (
    <button
      onClick={handlePhoneClick}
      className={className || "rounded-full shadow-lg bg-white text-gray-800 hover:bg-gray-100 px-4 py-2 flex items-center justify-center z-10"}
    >
      <Phone className="mr-2 h-4 w-4" />
      Appeler
    </button>
  );
};

export default TrackPhoneCall;
